import React, { Component } from 'react';
import styles from './Common.module.css';

class Empty extends Component {
  render() {
    const { iconStyle = '', children, extra } = this.props;

    return (
      <div className={styles.empty}>
        <div className={styles['emptyIcon' + iconStyle]} />
        <div className={styles.emptyTitle}>{children}</div>
        {extra ? extra : null}
      </div>
    );
  }
}

export default Empty;
